import { render, staticRenderFns } from "./BannersCarousel.vue?vue&type=template&id=94736a6a&"
import script from "./BannersCarousel.vue?vue&type=script&lang=js&"
export * from "./BannersCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BannersCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports